"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentStatus = void 0;
const sumPaymentReceipts_1 = require("./sumPaymentReceipts");
const paymentStatus = (payment, includePartialRefund) => {
    const paid = sumPaymentReceipts_1.sumReceipts(payment.receipts);
    const refund = sumPaymentReceipts_1.sumReceipts(payment.refunds);
    const totalPaid = paid - refund;
    if (payment.optionalStatus === 'needRefund' ||
        payment.optionalStatus === 'refunded') {
        if (payment.optionalStatus === 'needRefund' &&
            includePartialRefund &&
            refund > 0 &&
            refund < paid) {
            return 'partialRefund';
        }
        return payment.optionalStatus;
    }
    if (payment.optionalStatus === 'waitToPaid' &&
        payment.amountInEuro > totalPaid) {
        return payment.optionalStatus;
    }
    if ((payment.amountInEuro > 0 && totalPaid === 0) && payment.optionalStatus === "failed") {
        return 'failed';
    }
    if (payment.amountInEuro > 0 && totalPaid === 0) {
        return 'unpaid';
    }
    if (payment.amountInEuro > totalPaid) {
        return 'partial';
    }
    return 'paid';
};
exports.paymentStatus = paymentStatus;
//# sourceMappingURL=paymentStatus.js.map